var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "bobsukki.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "5",
            "price_rule_id": 1012397867202,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "NzQwNzc="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#1d85e8",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get 5% from friend's orders",
            "popup_description": "Send your friends a 5% discount off their purchase. Once they make a purchase, you'll earn 5% for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got 5% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}